import { render, staticRenderFns } from "./IndividualAnalysis.vue?vue&type=template&id=6d71d6c4&scoped=true"
import script from "./IndividualAnalysis.vue?vue&type=script&lang=js"
export * from "./IndividualAnalysis.vue?vue&type=script&lang=js"
import style0 from "./IndividualAnalysis.vue?vue&type=style&index=0&id=6d71d6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71d6c4",
  null
  
)

export default component.exports